import React, { useState } from 'react';
import { DollarSignIcon, DownloadIcon, CheckIcon, XIcon, ClockIcon, FileTextIcon, SearchIcon, FilterIcon, AlertCircleIcon, TrendingUpIcon } from 'lucide-react';
const payouts = [{
  id: 'PO-1001',
  customer: {
    name: 'Kosta Deris',
    avatar: 'https://i.pravatar.cc/150?img=1'
  },
  pro: {
    name: 'Ricardo',
    avatar: 'https://i.pravatar.cc/150?img=11'
  },
  proAmount: 250,
  realEstreamAmount: 50,
  totalAmount: 300,
  bookingId: '1410',
  service: 'Sign Installation',
  requestDate: '2025-11-12',
  status: 'pending',
  accountDetails: 'Bank Transfer - ***4532'
}, {
  id: 'PO-1002',
  customer: {
    name: 'Ken Matsumoto',
    avatar: 'https://i.pravatar.cc/150?img=3'
  },
  pro: {
    name: 'Johnson',
    avatar: 'https://i.pravatar.cc/150?img=12'
  },
  proAmount: 180,
  realEstreamAmount: 36,
  totalAmount: 216,
  bookingId: '1408',
  service: 'Handyman Services',
  requestDate: '2025-11-10',
  status: 'approved',
  accountDetails: 'Bank Transfer - ***7821'
}, {
  id: 'PO-1003',
  customer: {
    name: 'Sarah Johnson',
    avatar: 'https://i.pravatar.cc/150?img=4'
  },
  pro: {
    name: 'Mandarin Heating & Cooling Inc',
    avatar: 'https://i.pravatar.cc/150?img=13'
  },
  proAmount: 450,
  realEstreamAmount: 90,
  totalAmount: 540,
  bookingId: '1390',
  service: 'HVAC Repair & Installation',
  requestDate: '2025-10-15',
  status: 'completed',
  accountDetails: 'Bank Transfer - ***2341'
}];
const refunds = [{
  id: 'RF-2001',
  customer: {
    name: 'Kosta Deris',
    avatar: 'https://i.pravatar.cc/150?img=1'
  },
  pro: {
    name: 'Ricardo',
    avatar: 'https://i.pravatar.cc/150?img=11'
  },
  bookingId: '1409',
  service: 'Sign Installation',
  proAmount: 250,
  realEstreamAmount: 50,
  totalAmount: 300,
  reason: 'Service not completed as scheduled',
  requestDate: '2025-11-11',
  status: 'pending'
}, {
  id: 'RF-2002',
  customer: {
    name: 'Kosta Deris',
    avatar: 'https://i.pravatar.cc/150?img=1'
  },
  pro: {
    name: 'Johnson',
    avatar: 'https://i.pravatar.cc/150?img=12'
  },
  bookingId: '1407',
  service: 'Handyman Services',
  proAmount: 180,
  realEstreamAmount: 36,
  totalAmount: 216,
  reason: 'Duplicate booking error',
  requestDate: '2025-11-08',
  status: 'approved',
  processedDate: '2025-11-09'
}, {
  id: 'RF-2003',
  customer: {
    name: 'Sarah Johnson',
    avatar: 'https://i.pravatar.cc/150?img=4'
  },
  pro: {
    name: 'Yan Staging',
    avatar: 'https://i.pravatar.cc/150?img=14'
  },
  bookingId: '1402',
  service: 'Pool Inspection',
  proAmount: 300,
  realEstreamAmount: 60,
  totalAmount: 360,
  reason: 'Quality issues reported',
  requestDate: '2025-11-05',
  status: 'denied',
  denialReason: 'Service completed as per agreement',
  processedDate: '2025-11-06'
}];
const invoices = [{
  id: 'INV-3001',
  customer: {
    name: 'Kosta Deris',
    avatar: 'https://i.pravatar.cc/150?img=1'
  },
  pro: {
    name: 'Ricardo',
    avatar: 'https://i.pravatar.cc/150?img=11'
  },
  bookingId: '1410',
  service: 'Sign Installation',
  proAmount: 250,
  realEstreamAmount: 50,
  totalAmount: 300,
  tax: 39,
  total: 339,
  issueDate: '2025-11-11',
  dueDate: '2025-11-25',
  status: 'paid'
}, {
  id: 'INV-3002',
  customer: {
    name: 'Ken Matsumoto',
    avatar: 'https://i.pravatar.cc/150?img=3'
  },
  pro: {
    name: 'Mandarin Heating & Cooling Inc',
    avatar: 'https://i.pravatar.cc/150?img=13'
  },
  bookingId: '1390',
  service: 'HVAC Repair & Installation',
  proAmount: 450,
  realEstreamAmount: 90,
  totalAmount: 540,
  tax: 70.2,
  total: 610.2,
  issueDate: '2025-10-14',
  dueDate: '2025-10-28',
  status: 'paid'
}, {
  id: 'INV-3003',
  customer: {
    name: 'Kosta Deris',
    avatar: 'https://i.pravatar.cc/150?img=1'
  },
  pro: {
    name: 'Yan Staging',
    avatar: 'https://i.pravatar.cc/150?img=14'
  },
  bookingId: '1395',
  service: 'Staging/Design',
  proAmount: 500,
  realEstreamAmount: 100,
  totalAmount: 600,
  tax: 78,
  total: 678,
  issueDate: '2025-10-28',
  dueDate: '2025-11-11',
  status: 'overdue'
}];
export const FinancialsPage = () => {
  const [activeTab, setActiveTab] = useState('payouts');
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  return <div className="p-6 h-full flex flex-col" data-id="element-747">
      <div className="mb-6" data-id="element-748">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-749">Financials</h1>
        <p className="text-sm text-gray-500 mt-1" data-id="element-750">
          Manage payouts, refunds, and invoices
        </p>
      </div>
      <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-751">
        <div className="bg-white rounded-lg shadow border border-gray-100 p-4" data-id="element-752">
          <div className="flex items-center justify-between" data-id="element-753">
            <div data-id="element-754">
              <p className="text-sm text-gray-500" data-id="element-755">Pending Payouts</p>
              <p className="text-2xl font-bold text-gray-800 mt-1" data-id="element-756">
                $
                {payouts.filter(p => p.status === 'pending').reduce((sum, p) => sum + p.totalAmount, 0).toLocaleString()}
              </p>
            </div>
            <div className="h-12 w-12 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-757">
              <ClockIcon className="text-orange-600" size={24} data-id="element-758" />
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow border border-gray-100 p-4" data-id="element-759">
          <div className="flex items-center justify-between" data-id="element-760">
            <div data-id="element-761">
              <p className="text-sm text-gray-500" data-id="element-762">Pending Refunds</p>
              <p className="text-2xl font-bold text-gray-800 mt-1" data-id="element-763">
                $
                {refunds.filter(r => r.status === 'pending').reduce((sum, r) => sum + r.totalAmount, 0).toLocaleString()}
              </p>
            </div>
            <div className="h-12 w-12 bg-red-100 rounded-full flex items-center justify-center" data-id="element-764">
              <AlertCircleIcon className="text-red-600" size={24} data-id="element-765" />
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow border border-gray-100 p-4" data-id="element-766">
          <div className="flex items-center justify-between" data-id="element-767">
            <div data-id="element-768">
              <p className="text-sm text-gray-500" data-id="element-769">Total Revenue</p>
              <p className="text-2xl font-bold text-gray-800 mt-1" data-id="element-770">
                $
                {invoices.reduce((sum, i) => sum + i.total, 0).toLocaleString()}
              </p>
            </div>
            <div className="h-12 w-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-771">
              <TrendingUpIcon className="text-green-600" size={24} data-id="element-772" />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow border border-gray-100 flex-1 flex flex-col" data-id="element-773">
        <div className="border-b border-gray-200" data-id="element-774">
          <div className="flex space-x-1 px-6" data-id="element-775">
            <TabButton active={activeTab === 'payouts'} onClick={() => setActiveTab('payouts')} data-id="element-776">
              Payouts
            </TabButton>
            <TabButton active={activeTab === 'refunds'} onClick={() => setActiveTab('refunds')} data-id="element-777">
              Refunds
            </TabButton>
            <TabButton active={activeTab === 'invoices'} onClick={() => setActiveTab('invoices')} data-id="element-778">
              Invoices
            </TabButton>
          </div>
        </div>
        <div className="p-4 border-b border-gray-200" data-id="element-779">
          <div className="flex items-center justify-between" data-id="element-780">
            <div className="flex items-center space-x-2" data-id="element-781">
              <button className="p-2 rounded-md hover:bg-gray-100" data-id="element-782">
                <FilterIcon size={18} className="text-gray-500" data-id="element-783" />
              </button>
              <div className="relative" data-id="element-784">
                <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-785" />
                <input type="text" placeholder="Search..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10 pr-4 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 w-80" data-id="element-786" />
              </div>
              <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" data-id="element-787">
                <option value="all" data-id="element-788">All Status</option>
                <option value="pending" data-id="element-789">Pending</option>
                <option value="approved" data-id="element-790">Approved</option>
                <option value="completed" data-id="element-791">Completed</option>
                <option value="denied" data-id="element-792">Denied</option>
              </select>
            </div>
            {activeTab === 'invoices' && <button className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-793">
                <DownloadIcon size={16} className="mr-2" data-id="element-794" />
                Export Report
              </button>}
          </div>
        </div>
        <div className="flex-1 overflow-auto" data-id="element-795">
          {activeTab === 'payouts' && <PayoutsTable payouts={payouts} data-id="element-796" />}
          {activeTab === 'refunds' && <RefundsTable refunds={refunds} data-id="element-797" />}
          {activeTab === 'invoices' && <InvoicesTable invoices={invoices} data-id="element-798" />}
        </div>
      </div>
    </div>;
};
const TabButton = ({
  active,
  children,
  onClick
}) => {
  return <button onClick={onClick} className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${active ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`} data-id="element-799">
      {children}
    </button>;
};
const PayoutsTable = ({
  payouts
}) => {
  const [selectedPayout, setSelectedPayout] = useState(null);
  const getStatusBadge = status => {
    const statusConfig = {
      pending: {
        label: 'Pending',
        color: 'bg-orange-500 text-white'
      },
      approved: {
        label: 'Approved',
        color: 'bg-blue-500 text-white'
      },
      completed: {
        label: 'Completed',
        color: 'bg-green-500 text-white'
      }
    };
    const config = statusConfig[status] || statusConfig.pending;
    return <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${config.color}`} data-id="element-800">
        {config.label}
      </span>;
  };
  return <>
      <table className="w-full" data-id="element-801">
        <thead className="bg-gray-50 border-b border-gray-200 sticky top-0" data-id="element-802">
          <tr data-id="element-803">
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-804">
              Payout ID
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-805">
              Customer
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-806">
              Pro
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-807">
              Service
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-808">
              Pro Amount
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-809">
              Real Estream
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-810">
              Total Amount
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-811">
              Request Date
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-812">
              Status
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-813">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-814">
          {payouts.map(payout => <tr key={payout.id} className="hover:bg-gray-50" data-id="element-815">
              <td className="px-4 py-3 text-sm font-medium text-gray-900" data-id="element-816">
                {payout.id}
              </td>
              <td className="px-4 py-3" data-id="element-817">
                <div className="flex items-center" data-id="element-818">
                  <img src={payout.customer.avatar} alt={payout.customer.name} className="h-8 w-8 rounded-full mr-2" data-id="element-819" />
                  <span className="text-sm font-medium text-gray-900" data-id="element-820">
                    {payout.customer.name}
                  </span>
                </div>
              </td>
              <td className="px-4 py-3" data-id="element-821">
                <div className="flex items-center" data-id="element-822">
                  <img src={payout.pro.avatar} alt={payout.pro.name} className="h-8 w-8 rounded-full mr-2" data-id="element-823" />
                  <span className="text-sm font-medium text-gray-900" data-id="element-824">
                    {payout.pro.name}
                  </span>
                </div>
              </td>
              <td className="px-4 py-3 text-sm text-gray-900" data-id="element-825">
                {payout.service}
              </td>
              <td className="px-4 py-3 text-sm font-semibold text-gray-900" data-id="element-826">
                ${payout.proAmount}
              </td>
              <td className="px-4 py-3 text-sm font-semibold text-blue-600" data-id="element-827">
                ${payout.realEstreamAmount}
              </td>
              <td className="px-4 py-3 text-sm font-bold text-gray-900" data-id="element-828">
                ${payout.totalAmount}
              </td>
              <td className="px-4 py-3 text-sm text-gray-500" data-id="element-829">
                {payout.requestDate}
              </td>
              <td className="px-4 py-3" data-id="element-830">{getStatusBadge(payout.status)}</td>
              <td className="px-4 py-3" data-id="element-831">
                {payout.status === 'pending' && <div className="flex items-center space-x-2" data-id="element-832">
                    <button onClick={() => setSelectedPayout(payout)} className="p-1.5 bg-green-50 hover:bg-green-100 rounded text-green-600" data-id="element-833">
                      <CheckIcon size={16} data-id="element-834" />
                    </button>
                    <button className="p-1.5 bg-red-50 hover:bg-red-100 rounded text-red-600" data-id="element-835">
                      <XIcon size={16} data-id="element-836" />
                    </button>
                  </div>}
                {payout.status === 'approved' && <button className="px-3 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700" data-id="element-837">
                    Release Payment
                  </button>}
              </td>
            </tr>)}
        </tbody>
      </table>
      {selectedPayout && <PayoutApprovalModal payout={selectedPayout} onClose={() => setSelectedPayout(null)} data-id="element-838" />}
    </>;
};
const RefundsTable = ({
  refunds
}) => {
  const [selectedRefund, setSelectedRefund] = useState(null);
  const getStatusBadge = status => {
    const statusConfig = {
      pending: {
        label: 'Pending',
        color: 'bg-orange-500 text-white'
      },
      approved: {
        label: 'Approved',
        color: 'bg-green-500 text-white'
      },
      denied: {
        label: 'Denied',
        color: 'bg-red-500 text-white'
      }
    };
    const config = statusConfig[status] || statusConfig.pending;
    return <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${config.color}`} data-id="element-839">
        {config.label}
      </span>;
  };
  return <>
      <table className="w-full" data-id="element-840">
        <thead className="bg-gray-50 border-b border-gray-200 sticky top-0" data-id="element-841">
          <tr data-id="element-842">
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-843">
              Refund ID
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-844">
              Customer
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-845">
              Pro
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-846">
              Service
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-847">
              Pro Amount
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-848">
              Real Estream
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-849">
              Total Amount
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-850">
              Request Date
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-851">
              Status
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-852">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-853">
          {refunds.map(refund => <tr key={refund.id} className="hover:bg-gray-50" data-id="element-854">
              <td className="px-4 py-3 text-sm font-medium text-gray-900" data-id="element-855">
                {refund.id}
              </td>
              <td className="px-4 py-3" data-id="element-856">
                <div className="flex items-center" data-id="element-857">
                  <img src={refund.customer.avatar} alt={refund.customer.name} className="h-8 w-8 rounded-full mr-2" data-id="element-858" />
                  <span className="text-sm font-medium text-gray-900" data-id="element-859">
                    {refund.customer.name}
                  </span>
                </div>
              </td>
              <td className="px-4 py-3" data-id="element-860">
                <div className="flex items-center" data-id="element-861">
                  <img src={refund.pro.avatar} alt={refund.pro.name} className="h-8 w-8 rounded-full mr-2" data-id="element-862" />
                  <span className="text-sm font-medium text-gray-900" data-id="element-863">
                    {refund.pro.name}
                  </span>
                </div>
              </td>
              <td className="px-4 py-3 text-sm text-gray-900" data-id="element-864">
                {refund.service}
              </td>
              <td className="px-4 py-3 text-sm font-semibold text-gray-900" data-id="element-865">
                ${refund.proAmount}
              </td>
              <td className="px-4 py-3 text-sm font-semibold text-blue-600" data-id="element-866">
                ${refund.realEstreamAmount}
              </td>
              <td className="px-4 py-3 text-sm font-bold text-gray-900" data-id="element-867">
                ${refund.totalAmount}
              </td>
              <td className="px-4 py-3 text-sm text-gray-500" data-id="element-868">
                {refund.requestDate}
              </td>
              <td className="px-4 py-3" data-id="element-869">{getStatusBadge(refund.status)}</td>
              <td className="px-4 py-3" data-id="element-870">
                {refund.status === 'pending' ? <button onClick={() => setSelectedRefund(refund)} className="px-3 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700" data-id="element-871">
                    Review
                  </button> : <button className="px-3 py-1 bg-gray-100 text-gray-600 text-xs rounded" data-id="element-872">
                    View Details
                  </button>}
              </td>
            </tr>)}
        </tbody>
      </table>
      {selectedRefund && <RefundReviewModal refund={selectedRefund} onClose={() => setSelectedRefund(null)} data-id="element-873" />}
    </>;
};
const InvoicesTable = ({
  invoices
}) => {
  const getStatusBadge = status => {
    const statusConfig = {
      paid: {
        label: 'Paid',
        color: 'bg-green-500 text-white'
      },
      pending: {
        label: 'Pending',
        color: 'bg-orange-500 text-white'
      },
      overdue: {
        label: 'Overdue',
        color: 'bg-red-500 text-white'
      }
    };
    const config = statusConfig[status] || statusConfig.pending;
    return <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${config.color}`} data-id="element-874">
        {config.label}
      </span>;
  };
  return <table className="w-full" data-id="element-875">
      <thead className="bg-gray-50 border-b border-gray-200 sticky top-0" data-id="element-876">
        <tr data-id="element-877">
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-878">
            Invoice ID
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-879">
            Customer
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-880">
            Pro
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-881">
            Service
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-882">
            Pro Amount
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-883">
            Real Estream
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-884">
            Total Amount
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-885">
            Tax
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-886">
            Grand Total
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-887">
            Status
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-888">
            Actions
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-200" data-id="element-889">
        {invoices.map(invoice => <tr key={invoice.id} className="hover:bg-gray-50" data-id="element-890">
            <td className="px-4 py-3 text-sm font-medium text-gray-900" data-id="element-891">
              {invoice.id}
            </td>
            <td className="px-4 py-3" data-id="element-892">
              <div className="flex items-center" data-id="element-893">
                <img src={invoice.customer.avatar} alt={invoice.customer.name} className="h-8 w-8 rounded-full mr-2" data-id="element-894" />
                <span className="text-sm font-medium text-gray-900" data-id="element-895">
                  {invoice.customer.name}
                </span>
              </div>
            </td>
            <td className="px-4 py-3" data-id="element-896">
              <div className="flex items-center" data-id="element-897">
                <img src={invoice.pro.avatar} alt={invoice.pro.name} className="h-8 w-8 rounded-full mr-2" data-id="element-898" />
                <span className="text-sm font-medium text-gray-900" data-id="element-899">
                  {invoice.pro.name}
                </span>
              </div>
            </td>
            <td className="px-4 py-3 text-sm text-gray-900" data-id="element-900">
              {invoice.service}
            </td>
            <td className="px-4 py-3 text-sm font-semibold text-gray-900" data-id="element-901">
              ${invoice.proAmount}
            </td>
            <td className="px-4 py-3 text-sm font-semibold text-blue-600" data-id="element-902">
              ${invoice.realEstreamAmount}
            </td>
            <td className="px-4 py-3 text-sm font-bold text-gray-900" data-id="element-903">
              ${invoice.totalAmount}
            </td>
            <td className="px-4 py-3 text-sm text-gray-900" data-id="element-904">${invoice.tax}</td>
            <td className="px-4 py-3 text-sm font-bold text-green-600" data-id="element-905">
              ${invoice.total}
            </td>
            <td className="px-4 py-3" data-id="element-906">{getStatusBadge(invoice.status)}</td>
            <td className="px-4 py-3" data-id="element-907">
              <button className="p-1.5 hover:bg-gray-100 rounded text-blue-600" data-id="element-908">
                <DownloadIcon size={16} data-id="element-909" />
              </button>
            </td>
          </tr>)}
      </tbody>
    </table>;
};
const PayoutApprovalModal = ({
  payout,
  onClose
}) => {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-910">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full" data-id="element-911">
        <div className="p-6 border-b border-gray-200" data-id="element-912">
          <h2 className="text-xl font-bold text-gray-800" data-id="element-913">Approve Payout</h2>
        </div>
        <div className="p-6 space-y-4" data-id="element-914">
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-915">
            <span className="text-sm text-gray-600" data-id="element-916">Payout ID</span>
            <span className="text-sm font-medium text-gray-900" data-id="element-917">
              {payout.id}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-918">
            <span className="text-sm text-gray-600" data-id="element-919">Customer</span>
            <span className="text-sm font-medium text-gray-900" data-id="element-920">
              {payout.customer.name}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-921">
            <span className="text-sm text-gray-600" data-id="element-922">Pro</span>
            <span className="text-sm font-medium text-gray-900" data-id="element-923">
              {payout.pro.name}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-924">
            <span className="text-sm text-gray-600" data-id="element-925">Service</span>
            <span className="text-sm font-medium text-gray-900" data-id="element-926">
              {payout.service}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-927">
            <span className="text-sm text-gray-600" data-id="element-928">Pro Amount</span>
            <span className="text-lg font-bold text-gray-900" data-id="element-929">
              ${payout.proAmount}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-930">
            <span className="text-sm text-gray-600" data-id="element-931">Real Estream</span>
            <span className="text-lg font-bold text-blue-600" data-id="element-932">
              ${payout.realEstreamAmount}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-933">
            <span className="text-sm text-gray-600" data-id="element-934">Total Amount</span>
            <span className="text-lg font-bold text-gray-900" data-id="element-935">
              ${payout.totalAmount}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-936">
            <span className="text-sm text-gray-600" data-id="element-937">Account</span>
            <span className="text-sm font-medium text-gray-900" data-id="element-938">
              {payout.accountDetails}
            </span>
          </div>
        </div>
        <div className="p-6 border-t border-gray-200 flex space-x-3" data-id="element-939">
          <button onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100" data-id="element-940">
            Cancel
          </button>
          <button className="flex-1 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700" data-id="element-941">
            Approve Payout
          </button>
        </div>
      </div>
    </div>;
};
const RefundReviewModal = ({
  refund,
  onClose
}) => {
  const [denialReason, setDenialReason] = useState('');
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-942">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full" data-id="element-943">
        <div className="p-6 border-b border-gray-200" data-id="element-944">
          <h2 className="text-xl font-bold text-gray-800" data-id="element-945">Review Refund</h2>
        </div>
        <div className="p-6 space-y-4" data-id="element-946">
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-947">
            <span className="text-sm text-gray-600" data-id="element-948">Refund ID</span>
            <span className="text-sm font-medium text-gray-900" data-id="element-949">
              {refund.id}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-950">
            <span className="text-sm text-gray-600" data-id="element-951">Customer</span>
            <span className="text-sm font-medium text-gray-900" data-id="element-952">
              {refund.customer.name}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-953">
            <span className="text-sm text-gray-600" data-id="element-954">Pro</span>
            <span className="text-sm font-medium text-gray-900" data-id="element-955">
              {refund.pro.name}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-956">
            <span className="text-sm text-gray-600" data-id="element-957">Service</span>
            <span className="text-sm font-medium text-gray-900" data-id="element-958">
              {refund.service}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-959">
            <span className="text-sm text-gray-600" data-id="element-960">Pro Amount</span>
            <span className="text-lg font-bold text-gray-900" data-id="element-961">
              ${refund.proAmount}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-962">
            <span className="text-sm text-gray-600" data-id="element-963">Real Estream</span>
            <span className="text-lg font-bold text-blue-600" data-id="element-964">
              ${refund.realEstreamAmount}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-965">
            <span className="text-sm text-gray-600" data-id="element-966">Total Amount</span>
            <span className="text-lg font-bold text-gray-900" data-id="element-967">
              ${refund.totalAmount}
            </span>
          </div>
          <div className="py-2" data-id="element-968">
            <span className="text-sm text-gray-600 block mb-2" data-id="element-969">Reason</span>
            <p className="text-sm text-gray-900 bg-gray-50 p-3 rounded" data-id="element-970">
              {refund.reason}
            </p>
          </div>
          <div data-id="element-971">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-972">
              Denial Reason (Optional)
            </label>
            <textarea value={denialReason} onChange={e => setDenialReason(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" rows={3} placeholder="Enter reason if denying refund..." data-id="element-973" />
          </div>
        </div>
        <div className="p-6 border-t border-gray-200 flex space-x-3" data-id="element-974">
          <button onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100" data-id="element-975">
            Cancel
          </button>
          <button className="flex-1 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700" data-id="element-976">
            Deny
          </button>
          <button className="flex-1 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700" data-id="element-977">
            Approve
          </button>
        </div>
      </div>
    </div>;
};